import resource from '@/utils/pages/resources';

import userConfig from '@/pages/site/users.config';

export default resource({
  namespace: ['formaat'],
  name: 'client',
  key: 'code',
  creatable: true,
  editable: true,
  deletable: true,
  attributes: [
    ['code', { required: true }],
    ['name', { required: true }],
    ['users', ['resource', {
      multiple: true,
      name: 'user',
      config: userConfig,
      formatFn: ({ email }) => email,
      remote: {
        params: ({ query, values }) => ({ email: query, ids: values }),
      },
    }]],
  ],
});
